import {QueryParamsEnum} from 'presentation/constants';
import {useEffect, useRef, useState} from 'react';
import {useDebounce} from 'presentation/hooks';
import {useQueryParams} from '../../hooks';

export function useSearchProviders() {
	const {SEARCH_PARAMS, setSearchParams} = useQueryParams();
	const {query} = SEARCH_PARAMS;

	const [searchValueState, setSearchValueState] = useState(query || '');

	const latestQueryRef = useRef(query);

	const [debouncedQueryFunc, abortDebounce] = useDebounce(() => {
		const currentQuery = latestQueryRef.current;
		if (currentQuery.length > 2) {
			setSearchValueState(currentQuery);
		}
	}, 500);

	const clearSearchParams = () => {
		setSearchValueState('');
		setSearchParams(
			prev => {
				prev.delete(QueryParamsEnum.SEARCH_QUERY);
				return prev;
			},
			{
				replace: true,
			},
		);
	};

	useEffect(() => {
		latestQueryRef.current = query;
	}, [query]);

	return {
		searchValueState,
		debouncedQueryFunc,
		clearSearchParams,
		abortDebounce,
	};
}
